import { useAuth } from '../lib/auth'
import { SignInShell } from './SignIn'

/** Signed in, known, not yet let in. Nothing here reads the archive. */
export function Pending() {
  const { user, signOut } = useAuth()
  return (
    <SignInShell>
      <div className="signin-title">
        <h1 id="signin-title">Welcome back</h1>
        <p className="muted">
          Signed in as <span className="signin-email">{user?.email}</span>.
        </p>
      </div>
      <div role="status" className="signin-status">
        <p className="signin-alert-head">Your account is waiting for approval.</p>
        {/* The board says "An administrator has been told", but nothing
            tells one: a new account waits in Admin's Users section, counted
            in its "waiting for approval" pill, until an admin looks. */}
        <p className="muted">
          Administrators approve new accounts in the admin panel. Sign in
          again once your access is approved.
        </p>
      </div>
      <button type="button" className="button main" onClick={() => void signOut()}>
        Sign out
      </button>
    </SignInShell>
  )
}
